<template>
  <v-card flat color="transparent" outlined>
    <!-- Título + Acciones -->
    <v-row align="center" class="mb-4">
  <v-col cols="12" md="6" class="pb-0 pb-md-3">
    <h2 class="font-weight-bold mb-2" :class="{ 'text-h6': $vuetify.breakpoint.xsOnly }">Productos de la empresa</h2>
  </v-col>

  <v-col cols="12" md="6" class="d-flex flex-wrap justify-start justify-md-end" style="gap: 8px">
    <v-btn
      v-if="user && user.role.includes('admin')"
      color="error"
      depressed
      outlined
      class="btn-new-product"
      @click="abrirDialogEliminarProveedor"
    >
      <v-icon left small>mdi-delete-sweep-outline</v-icon>
      Eliminar por proveedor
    </v-btn>

    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          depressed
          class="btn-new-product"
          v-bind="attrs"
          v-on="on"
        >
          Registrar

          <v-icon right small>
            mdi-chevron-down
          </v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item
          @click="$router.push({ name: 'empresa.productos.registrar.selector' })"
        >
          <v-list-item-icon>
            <v-icon small>mdi-package-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              De forma individual
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          @click="$router.push({ name: 'empresa.productos.masivo.alta' })"
        >
          <v-list-item-icon>
            <v-icon small>mdi-table-arrow-up</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              Masivamente
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-col>
</v-row>

    <v-divider class="my-2"></v-divider>

    <!-- Tabs -->
    <v-tabs background-color="transparent" show-arrows>
      <v-tab :to="{ name: 'empresa.productosListado' }" exact class="no-uppercase" style="font-size: 15px">
        Gestión de productos
      </v-tab>
      <v-tab :to="{ name: 'empresa.productosCategorias' }" class="no-uppercase" style="font-size: 15px">
        Gestión de categorías
      </v-tab>
      <v-tab :to="{ name: 'empresa.productos.gestionPrecios' }" class="no-uppercase" style="font-size: 15px">
        Gestión de precios
      </v-tab>
      <v-tab :to="{ name: 'empresa.productos.centroCarga' }" class="no-uppercase" style="font-size: 15px">
        Centro de carga
      </v-tab>
      <v-tab :to="{ name: 'empresa.productos.controlCarga' }" class="no-uppercase" style="font-size: 15px">
        Control de carga
      </v-tab>
      <v-tab :to="{ name: 'empresa.productos.imagenesCarpeta' }" class="no-uppercase" style="font-size: 15px">
        Fotos
      </v-tab>
    </v-tabs>

    <!-- Dialog importar -->
    <v-dialog v-model="dialogImportar" max-width="480" persistent @keydown.esc="cerrarDialogImportar">
      <v-card class="import-dialog">
        <!-- Header -->
        <div class="import-dialog__header">
          <div>
            <div class="import-dialog__title">Importar productos</div>
            <div class="import-dialog__subtitle">
              {{ pasoImportar === 1 ? 'Descargá la plantilla con el formato requerido' : 'Subí el archivo con tus productos cargados' }}
            </div>
          </div>
          <v-btn icon small @click="cerrarDialogImportar">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Steps indicator -->
        <div class="import-dialog__steps">
          <div class="import-step" :class="{ 'import-step--active': pasoImportar === 1, 'import-step--done': pasoImportar > 1 }">
            <div class="import-step__num">
              <v-icon v-if="pasoImportar > 1" x-small color="white">mdi-check</v-icon>
              <span v-else>1</span>
            </div>
            <span class="import-step__label">Plantilla</span>
          </div>
          <div class="import-step__connector" :class="{ 'import-step__connector--done': pasoImportar > 1 }"></div>
          <div class="import-step" :class="{ 'import-step--active': pasoImportar === 2 }">
            <div class="import-step__num">2</div>
            <span class="import-step__label">Subir</span>
          </div>
        </div>

        <v-divider></v-divider>

        <div class="import-dialog__body">
          <!-- Paso 1 -->
          <template v-if="pasoImportar === 1">
            <p class="import-dialog__hint">
              Seleccioná un proveedor para descargar la plantilla. Los productos que cargues quedarán asociados a ese proveedor.
            </p>
            <v-autocomplete
              v-model="proveedorSeleccionado"
              :items="proveedoresImport"
              :loading="loadingProveedores"
              item-text="nombre"
              item-value="id"
              return-object
              label="Proveedor"
              outlined
              dense
              clearable
              hide-details
              no-data-text="Sin resultados"
              @update:search-input="buscarProveedores"
              class="mb-4"
            />
            <div class="d-flex align-center" style="gap: 8px">
              <v-btn
                depressed
                small
                color="primary"
                :disabled="!proveedorSeleccionado"
                :loading="loadingDescarga"
                @click="descargarPlantillaConProveedor"
              >
                <v-icon left small>mdi-download-outline</v-icon>
                Descargar
              </v-btn>
              <v-btn text small @click="pasoImportar = 2" class="text--secondary">
                Ya tengo la plantilla
              </v-btn>
            </div>
          </template>

          <!-- Paso 2 -->
          <template v-if="pasoImportar === 2">
            <div
              class="drop-zone"
              :class="{ 'drop-zone--has-file': !!archivo }"
              @dragover.prevent
              @drop.prevent="handleDrop"
            >
              <template v-if="!archivo">
                <v-icon size="36" color="grey darken-1">mdi-file-upload-outline</v-icon>
                <p class="drop-zone__text">Arrastrá el archivo aquí</p>
                <p class="drop-zone__sub">o seleccionalo desde tu equipo</p>
              </template>
              <template v-else>
                <v-icon size="36" color="success">mdi-file-check-outline</v-icon>
                <p class="drop-zone__text drop-zone__text--file">{{ archivo.name }}</p>
                <v-btn x-small text color="grey" @click="archivo = null">Cambiar archivo</v-btn>
              </template>
            </div>
            <v-file-input
              v-if="!archivo"
              v-model="archivo"
              accept=".xlsx"
              label="Seleccionar .xlsx"
              prepend-icon=""
              outlined
              dense
              hide-details
              class="mt-3"
            />
          </template>
        </div>

        <v-divider></v-divider>

        <div class="import-dialog__footer">
          <v-btn text small @click="cerrarDialogImportar" class="text--secondary">Cancelar</v-btn>
          <div class="d-flex" style="gap: 8px">
            <v-btn v-if="pasoImportar === 2" text small @click="pasoImportar = 1">Atrás</v-btn>
            <v-btn
              v-if="pasoImportar === 2"
              depressed
              small
              color="primary"
              :loading="loadingImport"
              :disabled="!archivo"
              @click="subirPlantilla"
            >
              Importar productos
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <router-view />

    <!-- Dialog eliminar productos por proveedor (solo admin) -->
    <v-dialog v-model="dialogEliminarProveedor" max-width="440" persistent @keydown.esc="cerrarDialogEliminarProveedor">
      <v-card>
        <v-card-title class="text-h6">Eliminar productos de un proveedor</v-card-title>
        <v-card-text>
          <p class="mb-4" style="font-size:13px;color:#888;">
            Se eliminarán <strong>todos los productos</strong> del proveedor seleccionado en esta empresa,
            incluyendo sus presentaciones y datos por sucursal. Esta acción no se puede deshacer.
          </p>
          <v-autocomplete
            v-model="proveedorEliminar"
            :items="proveedoresEliminar"
            :loading="loadingProveedoresEliminar"
            item-text="nombre"
            item-value="id"
            return-object
            label="Proveedor"
            outlined
            dense
            clearable
            hide-details
            no-data-text="Sin resultados"
            @update:search-input="buscarProveedoresEliminar"
          />
          <template v-if="proveedorEliminar">
            <p class="mt-4 mb-2" style="font-size:13px;">
              Para confirmar, escribí el nombre del proveedor:
              <strong>{{ proveedorEliminar.nombre }}</strong>
            </p>
            <v-text-field
              v-model="confirmacionEliminar"
              outlined
              dense
              hide-details
              autocomplete="off"
              placeholder="Nombre del proveedor"
            />
          </template>
        </v-card-text>
        <v-card-actions class="justify-end" style="gap:8px">
          <v-btn text small @click="cerrarDialogEliminarProveedor">Cancelar</v-btn>
          <v-btn
            depressed
            small
            color="error"
            :loading="loadingEliminarProveedor"
            :disabled="!confirmacionEliminarOk"
            @click="confirmarEliminarProductosProveedor"
          >
            Eliminar productos
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
  
  <script>
// import LayoutBasic from "@/layouts/productos/LayoutProductos";
import ProductosTableList from "@/components/producto/listar/ProductosTableList.vue";
import LayoutBasic from "@/layouts/LayoutBasic.vue";
import ProductoListado from "@/components/producto/listar/productos.list.card.vue";
import ProductoListTable from "@/components/producto/listar/productos.list.table.vue";
import ProductoDescripcionForm from "@/components/producto/form/form.producto.descripcion.vue";
import ProductoMarcaForm from "@/components/producto/form/form.producto.marca.vue";
import ProductoCategoriaForm from "@/components/producto/form/form.producto.categoria.vue";

import ProductoUnificarProductosPanel from "@/views/producto/ProductoUnificarProductosPanel.vue";

import ProductosActualizarPrecios from "@/components/producto/gestion/ProductosActualizarPrecios.vue";

import ProductoBuscador from "@/components/producto/buscador/producto.buscador.vue";

import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import ProductosFiltros from "@/components/producto/filtros/productos.filtros.vue";
import ProductosSucursalFiltros from "@/components/producto/filtros/ProductosSucursalFiltros.vue";

import ProductoModoEdicionPanels from "@/views/producto/gestion/ProductoModoEdicionPanels.vue";
import productos from "../../../api/productos";
import empresasApi from "../../../api/empresas";

export default {
  name: "GestionProductoHome",
  components: {
    ProductosTableList,
    ProductoUnificarProductosPanel,
    ProductosFiltros,
    ProductoBuscador,
    LayoutBasic,
    ProductoListado,
    ProductoListTable,
    ProductoDescripcionForm,
    ProductoMarcaForm,
    ProductoCategoriaForm,
    ProductosSucursalFiltros,
    ProductosActualizarPrecios,
    ProductoModoEdicionPanels,
  },
  data() {
    return {
    dialogImportar: false,
    pasoImportar: 1,
    archivo: null,
    loadingImport: false,
    loadingDescarga: false,
    proveedorSeleccionado: null,
    proveedoresImport: [],
    loadingProveedores: false,
    debounceTimerProveedores: null,
    dialogEliminarProveedor: false,
    confirmacionEliminar: "",
    proveedorEliminar: null,
    proveedoresEliminar: [],
    loadingProveedoresEliminar: false,
    loadingEliminarProveedor: false,
    debounceTimerProveedoresEliminar: null,
      productoSelectedEdit: null,
      usarProductoEmpresa: true,
      isUnificarProductos: false,
      itemMenu: 0,
      reload_search: 0,
      search: "",
      modoEdicion: null,
      items: [
        { title: "Editar Descripción", value: "descripcion" },
        { title: "Editar Marca", value: "marca" },
        { title: "Editar Categoría", value: "categoria" },
      ],

      links: [
        {
          icon: "mdi-format-list-bulleted-type",
          title: "Lista de productos",
        },
        {
          icon: "mdi-folder-plus",
          title: "Nuevo Producto",
          route: "nuevoProducto",
        },

        {
          icon: "mdi-clipboard-list",
          title: "Inventario",
          route: "productoInventarioGestion",
        },
        {
          icon: "mdi-pencil",
          title: "Editor masivo",
          route: "productosEditorMasivo",
        },
      ],
      modelMenu: 0,
      item: 1,
      productoSeleccionado: null,
      menuOpen: false, // 👈 esto es clave
      selectedItem: false,
    };
  },
  computed: {
    // Mismo criterio que el back: sin importar mayúsculas ni espacios de más
    confirmacionEliminarOk() {
      if (!this.proveedorEliminar) return false;
      const normalizar = (t) => (t || "").trim().split(/\s+/).join(" ").toUpperCase();
      return normalizar(this.confirmacionEliminar) === normalizar(this.proveedorEliminar.nombre);
    },
    ...mapGetters("proveedor", ["proveedores"]),
    ...mapGetters("marcas", ["marcas"]),
    ...mapState("productos", ["paginacion_productos_admin", "productos_admin"]),
    ...mapState("auth", ["user"]),

    queryParams() {
      return this.$route.query || "";
    },
    titulo() {
      return this.$route.query.categoria
        ? this.$route.query.categoria.split(/[-]+/).join(" ")
        : "Productos";
    },
  },

  methods: {
    ...mapActions("categorias", ["fetchCategoriasProductosFiltros"]),
    ...mapActions("productos", [
      "get_productos_for_params",
      "get_productos_empresa_for_params",
    ]),

    ...mapMutations("productos", ["set_page_productos_admin"]),
    abrirDialogEliminarProveedor() {
      this.dialogEliminarProveedor = true;
      this.buscarProveedoresEliminar("");
    },
    cerrarDialogEliminarProveedor() {
      this.dialogEliminarProveedor = false;
      this.proveedorEliminar = null;
      this.confirmacionEliminar = "";
      this.proveedoresEliminar = [];
    },
    buscarProveedoresEliminar(search) {
      clearTimeout(this.debounceTimerProveedoresEliminar);
      this.debounceTimerProveedoresEliminar = setTimeout(async () => {
        this.loadingProveedoresEliminar = true;
        try {
          const params = new URLSearchParams({ page: 1, page_size: 20 });
          if (search) params.append("search", search);
          const { data } = await this.axios.get(`/proveedores/?${params}`);
          this.proveedoresEliminar = Array.isArray(data.results) ? data.results : [];
        } catch (e) {
          this.proveedoresEliminar = [];
        } finally {
          this.loadingProveedoresEliminar = false;
        }
      }, 300);
    },
    async confirmarEliminarProductosProveedor() {
      if (!this.proveedorEliminar) return;
      this.loadingEliminarProveedor = true;
      try {
        const { data } = await empresasApi.eliminarProductosProveedor(
          this.proveedorEliminar.id,
          this.confirmacionEliminar
        );
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: `Se eliminaron ${data.eliminados} producto(s) del proveedor "${this.proveedorEliminar.nombre}"`,
          icon: "mdi-check",
          timeout: 4000,
        });
        this.cerrarDialogEliminarProveedor();
      } catch (e) {
        const detalle = e.response && e.response.data && e.response.data.detail;
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "error",
          text: detalle || "Error al eliminar los productos",
          icon: "mdi-alert",
          timeout: 3000,
        });
      } finally {
        this.loadingEliminarProveedor = false;
      }
    },
    cerrarDialogImportar() {
      this.dialogImportar = false;
      this.pasoImportar = 1;
      this.archivo = null;
      this.proveedorSeleccionado = null;
    },

    async buscarProveedores(search) {
      clearTimeout(this.debounceTimerProveedores);
      this.debounceTimerProveedores = setTimeout(async () => {
        this.loadingProveedores = true;
        try {
          const params = new URLSearchParams({ page: 1, page_size: 20 });
          if (search) params.append("search", search);
          const { data } = await this.axios.get(`/proveedores/?${params}`);
          this.proveedoresImport = Array.isArray(data.results) ? data.results : [];
        } catch (e) {
          this.proveedoresImport = [];
        } finally {
          this.loadingProveedores = false;
        }
      }, 300);
    },

    async descargarPlantillaConProveedor() {
      if (!this.proveedorSeleccionado) return;
      this.loadingDescarga = true;
      try {
        const response = await this.axios.get("productos/plantilla", {
          responseType: "blob",
          params: { proveedor: this.proveedorSeleccionado.id },
        });
        const disposition = response.headers["content-disposition"];
        const filename = disposition?.split("filename=")[1] ?? "plantilla_productos.xlsx";
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          color: "error",
          text: "Error al descargar la plantilla",
          icon: "mdi-alert",
          timeout: 3000,
        });
      } finally {
        this.loadingDescarga = false;
      }
    },

    descargarPlantillaProductos() {
      this.dialogImportar = true;
      this.pasoImportar = 1;
    },

    handleDrop(e) {
      const files = e.dataTransfer.files;
      if (files.length) this.archivo = files[0];
    },

    subirPlantilla() {
      this.loadingImport = true;
      const formData = new FormData();
      formData.append("file", this.archivo);
      this.axios
        .post("/productos/importar", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: "Productos importados",
            icon: "mdi-check",
            timeout: 3000,
          });
          this.cerrarDialogImportar();
        })
        .catch(() => {
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "error",
            text: "Error al importar archivo",
            icon: "mdi-alert",
            timeout: 3000,
          });
        })
        .finally(() => {
          this.loadingImport = false;
        });
    },

    removeSelected() {
      this.productoSeleccionado = null;
      this.selectedItem = false;
      this.productoSelectedEdit = null;
      this.modoEdicion = null;
      this.isUnificarProductos = false;
    },
    selectItem(item) {
      if (!this.menuOpen) {
        this.selectedItem = item;
      }
    },
    unSelectItem() {
      if (!this.menuOpen) {
        this.selectedItem = false;
      }
    },
    mostrarInfo(producto) {
      // Aquí obtienes el uuid_empresa de la ruta actual
      const uuid_empresa = this.$route.params.uuid_empresa;

      // Rediriges al usuario a la ruta 'productoEmpresaDetalle' pasando los parámetros necesarios
      this.$router.push({
        name: "productoEmpresaDetalle",
        params: {
          uuid_empresa: uuid_empresa,
          id_producto: producto.id,
        },
      });
    },
    editarPrecios(producto) {
      this.productoSeleccionado = JSON.parse(JSON.stringify(producto));
    },
    handleUnificacion() {
      this.$refs.tablaProductos.cleanSelected();
      this.setUnificarProductos();
      this.goToBuscador(this.search);
    },
    setProductoSelectedEdit(producto) {
      this.productoSelectedEdit = producto;
    },
    eliminarSeleccionados(productos) {
      console.log(productos);
    },
    setModoEdicion(modoEdicion, producto) {
      this.modoEdicion = modoEdicion;
      this.productoSelectedEdit = producto;
    },
    setProductosSelected(selected) {
      this.removeSelected();
    },
    setUnificarProductos() {
      this.isUnificarProductos = !this.isUnificarProductos;
    },

    goToBuscador(search) {
      console.log(search);

      if (search == "") {
        this.$router.replace({ path: "productos" }).catch((e) => {});
        return;
      }
      this.search = search;
      // if (search == this.$route.query.q) {
      //   return;
      // }
      this.set_page_productos_admin(1);
      var isBarcode = false;
      let isnum = /^\d+$/.test(search);

      if (isnum && search.length > 6) {
        isBarcode = true;
      }
      if (isBarcode) {
        this.add_query_url({ barcode: search });
      } else {
        this.add_query_url({ q: search });
      }

      this.fetchProductosEmpresa();
      // this.reload_search = !this.reload_search;
    },

    fetchProductosEmpresa() {
      this.set_page_productos_admin(1);
      var params = this.get_params_query();

      if (this.usarProductoEmpresa) {
        this.get_productos_empresa_for_params(params);
      } else {
        this.get_productos_for_params(params);
      }
    },

    get_text_transform(str) {
      if (typeof str === "string") {
        return str.match(/[^ ]+/g).join("-");
      } else {
        return str;
      }
    },
    add_query_url(value) {
      var querys = this.$route.query;

      for (const property in value) {
        var name = value[property];
        value[property] = this.get_text_transform(name);
        querys = Object.assign({}, querys, value);
      }
      this.$router.replace({ query: querys }).catch((error) => {
        if (error.name !== "NavigationDuplicated") {
          throw error;
        }
      });
    },
    get_params_query() {
      var array = [];
      var params = this.$route.params;
      if (params && params.categoria) {
        var object = {
          value: null,
          key: "",
        };
        object.value = params.categoria;
        object.key = "categoria";
        array.push(object);
      }

      var querys = this.$route.query;
      if (Object.keys(querys).length !== 0) {
        for (const property in querys) {
          var object = {
            nombre: null,
            key: "",
          };
          object.key = property;
          object.value = this.get_text_transform(querys[property]);
          array.push(object);
        }
      }
      array.push({ key: "global", value: true }); // Reemplaza "valor_global" con lo que necesites

      return array;
    },
  },
  watch: {
    dialogImportar(val) {
      if (val) this.buscarProveedores("");
    },
    // El listado lo pide cada hijo (ProductosEmpresaListado escucha $route.query);
    // pedirlo también acá duplicaba la request y pisaba el store de las otras pestañas.
  },
  // created () {
  //   this.fetchProductosEmpresa();
  // },
};
</script>
  
  <style>
.no-uppercase {
  text-transform: none !important;
}

/* Botones header */
.btn-minimal {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 500 !important;
  border-color: rgba(255,255,255,0.15) !important;
}

.btn-new-product {
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 500 !important;
}

/* Menu importar */
.import-menu {
  min-width: 260px;
}

.import-menu__item {
  padding: 10px 16px !important;
  height: auto !important;
}

.import-menu__title {
  font-size: 13px !important;
  font-weight: 500 !important;
}

.import-menu__sub {
  font-size: 11px !important;
  margin-top: 2px;
  white-space: normal !important;
  line-height: 1.4 !important;
}

/* Dialog importar */
.import-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}

.import-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 24px 16px;
}

.import-dialog__title {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
}

.import-dialog__subtitle {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

/* Steps */
.import-dialog__steps {
  display: flex;
  align-items: center;
  padding: 0 24px 16px;
  gap: 0;
}

.import-step {
  display: flex;
  align-items: center;
  gap: 8px;
}

.import-step__num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid #444;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #666;
  flex-shrink: 0;
  transition: all 0.2s;
}

.import-step--active .import-step__num {
  border-color: #1976d2;
  color: #1976d2;
}

.import-step--done .import-step__num {
  background: #1976d2;
  border-color: #1976d2;
}

.import-step__label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.import-step--active .import-step__label {
  color: #ccc;
}

.import-step--done .import-step__label {
  color: #888;
}

.import-step__connector {
  flex: 1;
  height: 1px;
  background: #2a2a2a;
  margin: 0 12px;
  transition: background 0.2s;
}

.import-step__connector--done {
  background: #1976d2;
}

/* Body y footer */
.import-dialog__body {
  padding: 20px 24px;
}

.import-dialog__hint {
  font-size: 13px;
  color: #888;
  margin-bottom: 16px;
  line-height: 1.5;
}

.import-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}

/* Drop zone */
.drop-zone {
  border: 1.5px dashed #2e2e2e;
  border-radius: 10px;
  padding: 32px 24px;
  text-align: center;
  transition: border-color 0.2s;
  cursor: default;
}

.drop-zone--has-file {
  border-color: #2e7d32;
  background: rgba(46, 125, 50, 0.04);
}

.drop-zone__text {
  font-size: 13px;
  font-weight: 500;
  color: #aaa;
  margin: 10px 0 4px;
}

.drop-zone__text--file {
  color: #ccc;
}

.drop-zone__sub {
  font-size: 11px;
  color: #555;
  margin: 0;
}
</style>
  